module.exports = __webpack_public_path__ + "static/media/keller.b2cc85b3.jpg";